import { FeatureBadge } from "@components/FeatureBadge";
import {
  ClockIcon,
  GlobeAltIcon,
  LightningBoltIcon,
  PencilIcon,
  RefreshIcon,
  ScaleIcon,
} from "@heroicons/react/outline";

export const CaseStudy = () => {
  return (
    <div className="container-lg ">
      <div className="-mx-24 bg-gray-200 px-24  pt-[72px] pb-[72px] dark:bg-blue-900 dark:text-white md:-mx-32  lg:-mx-28 lg:rounded-[32px] lg:px-28 xl:-mx-[90px] xl:px-[90px]">
        <div className="col-span-full ">
          <FeatureBadge>Case study</FeatureBadge>
        </div>
        <div className="grid-12">
          <div className="col-span-full md:col-span-6 ">
            <h3 className="mt-12 mb-32 font-display text-32-36 font-bold ">
              Copy AI makes $10m per year through better models
            </h3>
            <div className="prose max-w-[416px]  dark:text-white ">
              <p>
                You can build defensible and innovative products on top of
                powerful APIs – if you have the right tools to customize the
                models for your customers.
              </p>
              <p>
                Copy AI fine tune models on their best data, enabling cost
                savings and a competitive advantage. Enabling magical product
                experiences that delight over 2 million active users.
              </p>
            </div>
          </div>
          <div className="col-span-full mt-40 max-w-[500px] md:col-span-6">
            <img
              src="/assets/product/copyaitweet.png"
              alt="Copy AI announcing their two millionth user"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
